import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./edit-recipient-modal.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./edit-recipient-modal.component.scss?ngResource";
import { ChangeDetectorRef, Component, Input } from "@angular/core";
import { DefaultRequiredFields } from "../../../../../models/application/generic/recipient.model";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { SharedConstants } from "../../../../../constants/shared.constants";
import { Subject } from "rxjs";
import { RecipientFormConstants } from "../../shared-contants/recipient-shared.constants";
import { RecipientService } from "../../shared-services/recipient.service";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { AppControllerService } from "../../../../../../app-controller.service";
import RecipientUtils from "../../../../../utils/recipient-utils";
import { AlertType } from "../../../../../models/alert";
import { SubscriberComponent } from "../../../../subscriber/subscriber.component";
import { phoneNumberValidator } from "../../../../../classes/phone-number-validator";
import { RecipientSelectConstants } from "../../../recipient-select/recipient-select.constants";
export let EditRecipientModalComponent = class EditRecipientModalComponent extends SubscriberComponent {
    changeDetectorRef;
    recipientService;
    activeModal;
    appControllerService;
    dialogTitle = "Add new recipient";
    groupsFromMetadata = [];
    jobId;
    moduleId;
    groupsOptions = [];
    recipientToEdit;
    selectedRecipientGroups;
    showRecipientGroupsDropdown = true;
    showDefaultCommunicationMethods = true;
    editRecipientForm;
    Validator = Validators;
    sameAsResidentialChecked = false;
    disableEditing = false;
    provinceOptions = SharedConstants.PROVINCE;
    countryOptions = SharedConstants.COUNTRIES;
    groupsOptionsObservable = new Subject();
    selectedGroupsOptionsSubject = new Subject();
    defaultRequiredFields = DefaultRequiredFields;
    requiredFieldsPlaceHolder = RecipientFormConstants.requireFieldKey;
    formName = "editRecipient";
    validationMessage = RecipientFormConstants.validationMessage;
    nameLabel = RecipientFormConstants.nameLabel;
    surnameLabel = RecipientFormConstants.surnameLabel;
    homePhoneTelephoneLabel = RecipientFormConstants.homeTelePhoneLabel;
    workTelephoneLabel = RecipientFormConstants.workTelephoneLabel;
    cellphoneLabel = RecipientFormConstants.cellphoneLabel;
    emailLabel = RecipientFormConstants.emailLabel;
    defaultCommunicationMethodLabel = RecipientFormConstants.defaultCommunicationMethodLabel;
    organisationLabel = RecipientFormConstants.organisationLabel;
    clientVatNumberLabel = RecipientFormConstants.clientVatNumberLabel;
    designationLabel = RecipientFormConstants.designationLabel;
    professionalBodyHeader = RecipientFormConstants.professionalBodyHeader;
    professionalBodyLabel = RecipientFormConstants.professionalBodyLabel;
    professionalBodyRegNoLabel = RecipientFormConstants.professionalBodyRegNoLabel;
    streetAddressHeader = RecipientFormConstants.streetAddressHeader;
    streetAddressLabel = RecipientFormConstants.streetAddressLabel;
    streetSuburbLabel = RecipientFormConstants.streetSuburbLabel;
    streetCityLabel = RecipientFormConstants.streetCityLabel;
    streetProvinceLabel = RecipientFormConstants.streetProvinceLabel;
    streetCountryLabel = RecipientFormConstants.streetCountryLabel;
    streetCodeLabel = RecipientFormConstants.streetCodeLabel;
    postalDetailsHeader = RecipientFormConstants.postalDetailsHeader;
    postalAddressLabel = RecipientFormConstants.postalAddressLabel;
    postalSuburbLabel = RecipientFormConstants.postalSuburbLabel;
    postalCityLabel = RecipientFormConstants.postalCityLabel;
    postalProvinceLabel = RecipientFormConstants.postalProvinceLabel;
    postalCountryLabel = RecipientFormConstants.postalCountryLabel;
    postalCodeLabel = RecipientFormConstants.postalCodeLabel;
    sameAsStreetAddressLabel = RecipientFormConstants.sameAsStreetAddressLabel;
    groupsHeader = RecipientFormConstants.groups;
    groupsLabel = RecipientFormConstants.groupsLabel;
    selectOptionTextOption = RecipientSelectConstants.PLEASE_SELECT_AN_OPTION;
    // Form Controls
    nameFormControlName = RecipientFormConstants.nameFormControl;
    surnameFormControlName = RecipientFormConstants.surnameFormControl;
    homePhoneFormControlName = RecipientFormConstants.homeTelePhoneFormControl;
    workTelephoneFormControlName = RecipientFormConstants.workTelephoneFormControl;
    cellphoneFormControlName = RecipientFormConstants.cellphoneFormControlName;
    emailFormControlName = RecipientFormConstants.emailFormControlName;
    defaultCommunicationMethodFormControlName = RecipientSelectConstants.defaultCommunicationMethodFormControlName;
    emailRadioButtonLabel = RecipientFormConstants.emailRadioButtonLabel;
    smsRadioButtonLabel = RecipientSelectConstants.smsRadioButtonLabel;
    organisationFormControlName = RecipientFormConstants.organisationFormControlName;
    clientVatNumberFormControlName = RecipientFormConstants.clientVatNumberFormControlName;
    designationFormControlName = RecipientFormConstants.designationFormControlName;
    professionalBodyFormControlName = RecipientFormConstants.professionalBodyFormControlName;
    professionalBodyRegNoFormControlName = RecipientFormConstants.professionalBodyRegNoFormControlName;
    streetAddressFormControlName = RecipientFormConstants.streetAddressFormControlName;
    streetSuburbFormControlName = RecipientFormConstants.streetSuburbFormControlName;
    streetCityFormControlName = RecipientFormConstants.streetCityFormControlName;
    streetProvinceFormControlName = RecipientFormConstants.streetProvinceFormControlName;
    streetCountryFormControlName = RecipientFormConstants.streetCountryFormControlName;
    streetCodeFormControlName = RecipientFormConstants.streetCodeFormControlName;
    postalAddressFormControlName = RecipientFormConstants.postalAddressFormControlName;
    postalSuburbFormControlName = RecipientFormConstants.postalSuburbFormControlName;
    postalCityFormControlName = RecipientFormConstants.postalCityFormControlName;
    postalProvinceFormControlName = RecipientFormConstants.postalProvinceFormControlName;
    postalCountryFormControlName = RecipientFormConstants.postalCountryFormControlName;
    postalCodeFormControlName = RecipientFormConstants.postalCodeFormControlName;
    groupsStringArrayFormControlName = RecipientFormConstants.groupsStringArrayFormControlName;
    maximunLengthForThentyWord = 20;
    maximunLengthForFiftyWord = 50;
    maximunLengthForHundredWord = 100;
    maximunLengthForTwoFiftyWord = 250;
    maximunLengthFiveHundredWord = 500;
    cancelBtnPlaceholder = SharedConstants.CANCEL_LABEL;
    saveBtnPlaceholder = SharedConstants.SAVE_LABEL;
    newRecipientFormLabelHeading = "Recipient details";
    constructor(changeDetectorRef, recipientService, activeModal, appControllerService) {
        super();
        this.changeDetectorRef = changeDetectorRef;
        this.recipientService = recipientService;
        this.activeModal = activeModal;
        this.appControllerService = appControllerService;
    }
    ngOnInit() {
        this.editRecipientForm = new FormGroup({
            id: new FormControl(this.recipientToEdit.id),
            jobId: new FormControl(this.recipientToEdit.jobId ? this.recipientToEdit.jobId : null),
            moduleId: new FormControl(this.recipientToEdit.moduleId ? this.recipientToEdit.moduleId : null),
            name: new FormControl(this.recipientToEdit.name ? this.recipientToEdit.name : null),
            surname: new FormControl(this.recipientToEdit.surname ? this.recipientToEdit.surname : null),
            homePhone: new FormControl(this.recipientToEdit.homePhone ? this.recipientToEdit.homePhone : null, phoneNumberValidator),
            telephone: new FormControl(this.recipientToEdit.telephone ? this.recipientToEdit.telephone : null, phoneNumberValidator),
            cellphone: new FormControl(this.recipientToEdit.cellphone ? this.recipientToEdit.cellphone : null, phoneNumberValidator),
            email: new FormControl(this.recipientToEdit.email ? this.recipientToEdit.email : null, Validators.email),
            defaultCommunicationMethod: new FormControl(this.recipientToEdit.defaultCommunicationMethod ? this.recipientToEdit.defaultCommunicationMethod : null),
            organisation: new FormControl(this.recipientToEdit.organisation ? this.recipientToEdit.organisation : null),
            clientVatNumber: new FormControl(this.recipientToEdit.clientVatNumber ? this.recipientToEdit.clientVatNumber : null),
            designation: new FormControl(this.recipientToEdit.designation ? this.recipientToEdit.designation : null),
            professionalBody: new FormControl(this.recipientToEdit.professionalBody ? this.recipientToEdit.professionalBody : null),
            professionalBodyRegNum: new FormControl(this.recipientToEdit.professionalBodyRegNum ? this.recipientToEdit.professionalBodyRegNum : null),
            streetAddress: new FormControl(this.recipientToEdit.streetAddress ? this.recipientToEdit.streetAddress : null),
            streetSuburb: new FormControl(this.recipientToEdit.streetSuburb ? this.recipientToEdit.streetSuburb : null),
            streetCity: new FormControl(this.recipientToEdit.streetCity ? this.recipientToEdit.streetCity : null),
            streetProvince: new FormControl(this.recipientToEdit.streetProvince ? this.recipientToEdit.streetProvince : null),
            streetCountry: new FormControl(this.recipientToEdit.streetCountry ? this.recipientToEdit.streetCountry : null),
            streetCode: new FormControl(this.recipientToEdit.streetCode ? this.recipientToEdit.streetCode : null),
            postalAddress: new FormControl(this.recipientToEdit.postalAddress ? this.recipientToEdit.postalAddress : null),
            postalSuburb: new FormControl(this.recipientToEdit.postalSuburb ? this.recipientToEdit.postalSuburb : null),
            postalCity: new FormControl(this.recipientToEdit.postalCity ? this.recipientToEdit.postalCity : null),
            postalProvince: new FormControl(this.recipientToEdit.postalProvince ? this.recipientToEdit.postalProvince : null),
            postalCountry: new FormControl(this.recipientToEdit.postalCountry ? this.recipientToEdit.postalCountry : null),
            postalCode: new FormControl(this.recipientToEdit.postalCode ? this.recipientToEdit.postalCode : null),
            groupsStringArray: new FormControl(this.getGroupsStringArray(this.recipientToEdit.groups)),
            groups: new FormControl(this.recipientToEdit.groups ? this.recipientToEdit.groups : null)
        });
        this.checkRequiredFields();
    }
    ngAfterViewInit() {
        this.populateRecipientGroups();
        this.checkIfPostalDetailsIsTheSameAsResidentialDetails(this.recipientToEdit);
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        this.selectedGroupsOptionsSubject.unsubscribe();
        this.groupsOptionsObservable.unsubscribe();
    }
    onResidentialInputEntered($event, postalAddressFormControlName) {
        RecipientUtils.onResidentialInputEntered($event, postalAddressFormControlName, this.editRecipientForm, this.sameAsResidentialChecked);
    }
    onSameAsResidentialChecked($event) {
        const checkBoxStatus = $event.target.checked;
        if (checkBoxStatus) {
            this.sameAsResidentialChecked = true; // checks the checkbox and disables fields
            RecipientUtils.copyStreetDetailsDataToPostalDetailsFields(this.editRecipientForm, this.sameAsResidentialChecked);
            RecipientUtils.clearPostalDetailsValidators(this.editRecipientForm, this.sameAsResidentialChecked);
        }
        else {
            this.sameAsResidentialChecked = false;
            RecipientUtils.enablePostalDetails(this.editRecipientForm);
            RecipientUtils.restorePostalDetailsValidators(this.editRecipientForm, this.groupsFromMetadata);
            this.editRecipientForm.updateValueAndValidity();
            this.changeDetectorRef.detectChanges();
        }
    }
    enablePostalSelects(postalProvinceFormControlName) {
        RecipientUtils.enablePostalSelects(this.editRecipientForm, postalProvinceFormControlName, this.sameAsResidentialChecked);
    }
    disablePostalSelects(postalProvinceFormControlName) {
        RecipientUtils.disablePostalSelects(this.editRecipientForm, postalProvinceFormControlName, this.sameAsResidentialChecked);
    }
    onCancelBtnClicked() {
        this.activeModal.close();
    }
    onSaveBtnClicked() {
        if (this.editRecipientForm.valid) {
            this.editRecipientForm.enable();
            const newRecipient = this.editRecipientForm.value;
            newRecipient.jobId = this.jobId ? +this.jobId : null;
            newRecipient.moduleId = this.moduleId;
            if (newRecipient.groupsStringArray && newRecipient.groupsStringArray.groups) {
                newRecipient.groupsStringArray = newRecipient.groupsStringArray.groups;
            }
            else {
                newRecipient.groups = [];
            }
            delete newRecipient.groups;
            this.activeModal.close(newRecipient);
        }
        else {
            this.appControllerService.showMessage(SharedConstants.FORM_NOT_VALID, AlertType.Warning);
        }
    }
    updateModel() {
    }
    onRadioButtonChanged(selectedMethodOfCommunication) {
        const preferredMethodOfCommunication = selectedMethodOfCommunication.trim().toLowerCase();
        const emailFormControl = this.editRecipientForm.get(this.emailFormControlName);
        const cellphoneFormControl = this.editRecipientForm.get(this.cellphoneFormControlName);
        const recipientGroup = this.groupsFromMetadata[0];
        const isCellPhoneRequiredFromMetaData = this.isCellphoneFormFieldRequiredInTheMetadata(recipientGroup);
        const isEmailRequiredFromMetadata = this.isEmailFormFieldRequiredInTheMetadata(recipientGroup);
        if (preferredMethodOfCommunication.toLowerCase().trim() === "email") {
            this.setEmailFormFieldAsRequired(emailFormControl);
            if (isCellPhoneRequiredFromMetaData) {
                this.setCellphoneFormFieldAsRequired(cellphoneFormControl);
            }
            else {
                this.clearCellphoneFormFieldRequiredValidation(cellphoneFormControl);
            }
        }
        if (preferredMethodOfCommunication.toLowerCase().trim() === "sms") {
            this.setCellphoneFormFieldAsRequired(cellphoneFormControl);
            if (isEmailRequiredFromMetadata) {
                this.setEmailFormFieldAsRequired(emailFormControl);
            }
            else {
                this.clearEmailFormFieldRequiredValidation(emailFormControl);
            }
        }
    }
    populateRecipientGroups() {
        // populates the groups
        this.groupsOptions?.sort((a, b) => a?.localeCompare(b));
        this.changeDetectorRef.detectChanges();
    }
    checkRequiredFields() {
        if (this.groupsFromMetadata[0].hasOwnProperty("requiredFields") && Object.keys(this.groupsFromMetadata[0].requiredFields)?.length > 0) {
            this.loadRequiredFields(this.groupsFromMetadata[0].requiredFields);
            this.editRecipientForm.updateValueAndValidity();
        }
        else {
            this.groupsFromMetadata[0].requiredFields = this.defaultRequiredFields;
            this.loadRequiredFields(this.groupsFromMetadata[0].requiredFields);
        }
    }
    checkIfPostalDetailsIsTheSameAsResidentialDetails(recipient) {
        const postalDetailsMatchResidentialDetails = RecipientUtils.checkAddressDetails(recipient, this.editRecipientForm);
        if (postalDetailsMatchResidentialDetails) {
            RecipientUtils.disablePostalDetails(this.editRecipientForm);
            this.sameAsResidentialChecked = true;
            this.changeDetectorRef.detectChanges();
        }
    }
    getGroupsStringArray(groups) {
        const groupsStringArray = [];
        if (groups && groups.length > 0) {
            groups.forEach((group) => {
                groupsStringArray.push(group.groupName);
            });
        }
        return groupsStringArray;
    }
    loadRequiredFields(requiredFields) {
        for (const [fieldName, isRequired] of Object.entries(requiredFields)) {
            if (isRequired) {
                RecipientUtils.checkRequiredFields(this.groupsFromMetadata, this.editRecipientForm);
            }
        }
    }
    isCellphoneFormFieldRequiredInTheMetadata(recipientGroup) {
        let isCellphoneRequired = false;
        if (this.groupsFromMetadata.length > 0 && recipientGroup.hasOwnProperty(this.requiredFieldsPlaceHolder) && this.getPropertyThatMatchesDataCase(recipientGroup.requiredFields, "Cellphone", "cellphone")) {
            isCellphoneRequired = true;
        }
        return isCellphoneRequired;
    }
    isEmailFormFieldRequiredInTheMetadata(recipientGroup) {
        let isEsmailRequired = false;
        if (this.groupsFromMetadata.length > 0 && recipientGroup.hasOwnProperty(this.requiredFieldsPlaceHolder) && this.getPropertyThatMatchesDataCase(recipientGroup.requiredFields, "Email", "email")) {
            isEsmailRequired = true;
        }
        return isEsmailRequired;
    }
    setEmailFormFieldAsRequired(emailFormControl) {
        emailFormControl.setValidators([Validators.required, Validators.email]);
        emailFormControl.updateValueAndValidity();
    }
    setCellphoneFormFieldAsRequired(cellphoneFormControl) {
        cellphoneFormControl.setValidators([Validators.required, phoneNumberValidator]);
        cellphoneFormControl.updateValueAndValidity();
    }
    clearCellphoneFormFieldRequiredValidation(cellphoneFormControl) {
        cellphoneFormControl.clearValidators();
        cellphoneFormControl.addValidators(phoneNumberValidator);
    }
    clearEmailFormFieldRequiredValidation(emailFormControl) {
        emailFormControl.clearValidators();
        emailFormControl.addValidators(Validators.email);
    }
    getPropertyThatMatchesDataCase(propertyObject, name1, name2) {
        let returnVal = null;
        for (const [key, value] of Object.entries(propertyObject)) {
            if (key === name1) {
                returnVal = propertyObject.hasOwnProperty(name1) && value !== null ? value : null;
                break;
            }
            else if (key === name1.toLowerCase()) {
                returnVal = propertyObject.hasOwnProperty(name1.toLowerCase()) && value !== null ? value : null;
                break;
            }
            else if (name2 && key === name2) {
                returnVal = propertyObject.hasOwnProperty(name2) && value !== null ? value : null;
                break;
            }
        }
        return returnVal;
    }
    static ctorParameters = () => [
        { type: ChangeDetectorRef },
        { type: RecipientService },
        { type: NgbActiveModal },
        { type: AppControllerService }
    ];
    static propDecorators = {
        dialogTitle: [{ type: Input }],
        groupsFromMetadata: [{ type: Input }],
        jobId: [{ type: Input }],
        moduleId: [{ type: Input }],
        groupsOptions: [{ type: Input }],
        recipientToEdit: [{ type: Input }],
        selectedRecipientGroups: [{ type: Input }],
        showRecipientGroupsDropdown: [{ type: Input }],
        showDefaultCommunicationMethods: [{ type: Input }]
    };
};
EditRecipientModalComponent = __decorate([
    Component({
        selector: "app-edit-recipient-modal",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], EditRecipientModalComponent);
